export enum ProductFigurineStatus {
	ToDo = "ToDo",
	Ready = "Ready",
}

export const productFigurineStatusNameMap: Record<ProductFigurineStatus, string> = {
	[ProductFigurineStatus.ToDo]: "TODO",
	[ProductFigurineStatus.Ready]: "Připravená",
};
